<section class="faq-section">
  @let hasIntro = (intro() || '' | stripHtml).length > 0;
  <h2 class="h3" [class.mb-2]="hasIntro">{{ title() || collectionTitle() }}</h2>

  @if (hasIntro) {
    <div class="markdown-content text-max-width-md" [innerHTML]="intro() || ''"></div>
  }

  <div class="faq-grid row" [ngClass]="isGrid$() ? 'masonry' : 'row gutter-y-4'">
    @for (cat of getKeys(group()); track cat; let i = $index) {
      <div class="faq-grid__item mb-4" [ngClass]="isGrid$() ? 'col-md-6' : 'col-12 col-12 mb-md-0'">
        <p class="h6 fs-body-md text-primary mb-2 fw-semi">{{ cat }}</p>

        <mat-accordion>
          @for (faq of group()[cat]; track $index; let i = $index) {
            <mat-expansion-panel
              class="mat-elevation-z0"
              (opened)="openItem(cat, i)"
              (closed)="openPanels()[cat] === i ? (openPanels()[cat] = null) : null"
              [ngClass]="{
                'mat-before-expanded': openPanels()[cat] !== null && openPanels()[cat] - 1 === i,
                'mat-after-expanded': openPanels()[cat] !== null && openPanels()[cat] + 1 === i,
              }"
            >
              <mat-expansion-panel-header>
                <mat-panel-title class="fs-body-md fw-normal">
                  <h3 class="fw-normal fs-body-md mb-0">{{ faq.question }}</h3>
                </mat-panel-title>
              </mat-expansion-panel-header>

              @if (faq.answer) {
                <div
                  class="markdown-content"
                  fstrDynamicContent
                  [innerHTML]="faq.answer | resizeHtmlImages | stripEmbed: cookiePreferences() | safe"
                ></div>
              }
            </mat-expansion-panel>
          }
        </mat-accordion>
      </div>
    }
  </div>
</section>

<app-json-ld [json]="scheme()"></app-json-ld>
